<div>
    <p class="ss-row ss-align-ic ss-size-22 ss-color-brown-grey ss-heebo">
        <span>{{options.unchecked.name}}</span>
        <span>{{options.checked.name}}</span>
    </p>
    <mat-slide-toggle class="example-margin" (change)="toggleValue($event)"></mat-slide-toggle>
</div>
